import { AxiosInstance } from 'axios'
import { MediaObject } from '@/shared/api/strapi/requests/types'

export type GetSearchServicesArgs = {
  locale: string
}

export type SearchServicesDTO = {
  data: Service[]
}

export type Service = {
  id: number
  attributes: {
    name: string
    slug: string
    image: MediaObject
  }
}

export const getSearchServices = async (client: AxiosInstance, { locale }: GetSearchServicesArgs) => {
  const path = `/services`
  const params = {
    locale: locale,
    fields: ['name', 'slug'],
    populate: {
      image: { populate: '*' },
    },
    // pagination: {
    //   start: 0,
    //   limit: Infinity,
    // },
  }

  return (await client.get<SearchServicesDTO>(path, { params })).data.data
}
